import template from './departments_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class DepartmentsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class DepartmentsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new DepartmentsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'DepartmentsHelp',
	dialog_class: DepartmentsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/departments_help',
	provider: 'ps'
};
